import { Link } from '@tanstack/react-router'
import { trackAnalyticsEvent } from '@client/analytics'

export function Footer() {
  return (
    <footer className="border-t border-border/70 bg-background">
      <div className="container mx-auto max-w-6xl px-6 py-10 text-center">
        <div className="mb-6 flex flex-wrap items-center justify-center gap-6 text-sm font-medium text-muted-foreground">
          <Link
            to="/terms"
            onClick={() =>
              trackAnalyticsEvent('navigation_clicked', {
                destination: '/terms',
                label: 'terms',
                location: 'footer',
              })
            }
            className="transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm"
          >
            Terms of Service
          </Link>
          <Link
            to="/privacy"
            onClick={() =>
              trackAnalyticsEvent('navigation_clicked', {
                destination: '/privacy',
                label: 'privacy',
                location: 'footer',
              })
            }
            className="transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm"
          >
            Privacy Policy
          </Link>
          <Link
            to="/contact"
            onClick={() =>
              trackAnalyticsEvent('navigation_clicked', {
                destination: '/contact',
                label: 'contact',
                location: 'footer',
              })
            }
            className="transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm"
          >
            Contact
          </Link>
        </div>

        <div className="pt-6 text-sm text-muted-foreground">
          <p className="mb-2 font-medium">
            Copyright &copy; {new Date().getFullYear()} Tidy Technology Ltd
          </p>
          <p className="mx-auto max-w-3xl text-xs leading-relaxed">
            71-75 Shelton Street, London, WC2H 9JQ, United Kingdom
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
